export default __webpack_public_path__ + "static/media/SwimmingPool.0f2687fb.webp";